import { StyleSheet, Text } from "@react-pdf/renderer";
import React from "react";

export const textFlagColors: { [key: string]: string } = {
    success: "#13a55f",
    green: "#13a55f",
    danger: "#dc3545",
    red: "#dc3545",
    warning: "#ffc107",
    yellow: "#ffc107",
};

export const flagContrastColors: { [key: string]: string } = {
    success: "white",
    green: "white",
    danger: "white",
    red: "white",
    warning: "black",
    yellow: "black",
};

interface ColorCodedSpanProps {
    children: React.ReactNode;
    flag?: string;
}

export function ColorCodedSpan({ children, flag }: ColorCodedSpanProps) {
    const className = flag && textFlagColors[flag] ? `text-${flag}` : "";
    return <span className={className}>{children}</span>;
}

const defaultStyles = StyleSheet.create({
    badge: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        borderRadius: 100,
        textAlign: "center",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        overflow: "hidden",
        fontSize: 10
    },
    text: {
        overflow: "hidden",
        fontSize: 9
    },
    swatch: {
        width: 80,
        padding: 8,
    }
});

interface ColorCodedVectorProps {
    children: React.ReactNode;
    flag?: string;
    style?: any;
    variant?: "badge" | "text" | "swatch"
}

export const ColorCodedVector = ({ children, flag, style = {}, variant = "text" }: ColorCodedVectorProps) => {
    const flagColor = flag && textFlagColors[flag] ? textFlagColors[flag] : flag;
    const contrastColor = flag && flagContrastColors[flag] ? flagContrastColors[flag] : "black";
    const color = variant === "text" ? flagColor : contrastColor;
    const backgroundColor = variant === "text" ? "transparent" : flagColor;

    return (
        <Text style={{ ...defaultStyles[variant], ...style, color, backgroundColor }}>
            {variant !== "swatch" ? children : null}
        </Text>
    );
};
